import { render, staticRenderFns } from "./OrphanTracks.vue?vue&type=template&id=64fade00&"
import script from "./OrphanTracks.vue?vue&type=script&lang=js&"
export * from "./OrphanTracks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports